import React, { useEffect, useRef, useState } from "react";
import Hero from "./Hero";
import Reviews from "./Review";
import FeaturedCard from "./FeaturedCard";
import EnquiryForm from "./EnquiryForm";
import Location from "./MapSection";
import NewsEventsCard from "../NewsEventsCard";
import Odometer from "react-odometerjs";
import "odometer/themes/odometer-theme-default.css";
import AlumniSection from "./AlumniSection";
import NoticeInfo from "./NoticeInfo";
import MapSection from "./MapSection";
import { Link } from "react-router-dom";
import homepageAPI from "../../api/homepageApi";
import { useSiteConfig } from "../../context/SiteConfigContext";

const Home = () => {
  const { siteConfig } = useSiteConfig();
  const [aboutUs, setAboutUs] = useState([]);
  const [chooseMrv, setChooseMrv] = useState([]);
  const [campus, setCampus] = useState([]);
  const [newsEvents, setNewsEvents] = useState([]);
  const [testimonial, setTestimonial] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [featured, setFeatured] = useState([]);
  const [teachingMethodology, setTeachingMethodology] = useState([]);
  const [admission, setAdmission] = useState(null);
  const [noticeData, setNoticeData] = useState([]);
  const [alumni, setAlumni] = useState([]);
  const [admissionCta, setAdmissionCta] = useState([]);

  useEffect(() => {
    fetchHomepageData();
  }, []);

  const CACHE_TIME = 3 * 60 * 1000;

  const applyData = (result) => {
    setAboutUs(result?.["about-us"] || []);
    setChooseMrv(result?.["choose-mrv"] || []);
    setCampus(result?.["campus-facilities"] || []);
    setNewsEvents(result?.["latest-event"] || []);
    setTestimonial(result?.testimonial || []);
    setGallery(result?.gallery || []);
    setFeatured(result?.["featured-session"] || []);
    setTeachingMethodology(result?.["our-teaching"] || []);
    setAdmission(result?.["admission"] || []);
    setNoticeData(result?.["notice-board"] || []);
    setAlumni(result?.["alumni"] || []);
    setAdmissionCta(result?.["admission-cta"] || []);
  };

  const fetchHomepageData = async () => {
    try {
      const cached = sessionStorage.getItem("homeData");
      const parsed = cached ? JSON.parse(cached) : null;

      if (parsed?.data) {
        applyData(parsed.data);
      }

      const isExpired = !parsed || Date.now() - parsed.timestamp > CACHE_TIME;

      if (isExpired) {
        const res = await homepageAPI.homepage_list();

        if (res.code === 200) {
          sessionStorage.setItem(
            "homeData",
            JSON.stringify({
              data: res.data,
              timestamp: Date.now(),
            }),
          );

          applyData(res.data);
        }
      }
    } catch (error) {
      console.error("Home API Error:", error);
    }
  };
  // const fetchHomepageData = async () => {
  //   const res = await homepageAPI.homepage_list();

  //   if (res.code === 200) {
  //     const result = res.data;

  //     setAboutUs(result?.["about-us"]);
  //     setChooseMrv(result?.["choose-mrv"]);
  //     setCampus(result?.["campus-facilities"]);
  //     setNewsEvents(result?.["latest-event"]);
  //     setTestimonial(result?.testimonial);
  //     setGallery(result?.gallery);
  //     setFeatured(result?.["featured-session"]);
  //     setTeachingMethodology(result?.["our-teaching"]);
  //     setAdmission(result?.["admission"]);
  //     setNoticeData(result?.["notice-board"]);
  //     setAlumni(result?.["alumni"]);
  //     setAdmissionCta(result?.["admission-cta"]);
  //   }
  // };

  const aboutInfo = aboutUs[0];
  const chooseMrvInfo = chooseMrv[0];
  const campusInfo = campus[0];
  const latestEvent = newsEvents[0];
  const testimonialInfo = testimonial[0];
  const galleryInfo = gallery[0];
  const featuredInfo = featured[0];
  const teachingInfo = teachingMethodology[0];
  const admissionInfo = admission?.[0];
  const noticeInfo = noticeData[0];
  const admissionCtaInfo = admissionCta[0];

  const [isPlaying, setIsPlaying] = useState(false);

  // teachers methodology data
  const videoRef = useRef(null);

  // play video
  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  // pause detect
  const handlePause = () => {
    setIsPlaying(false);
  };

  const sectionRef = useRef(null);
  const [startCount, setStartCount] = useState(false);
  // counter animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => setStartCount(true), 200);
          }
        });
      },
      { threshold: 0.2 },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Hero />
      {/* about section */}
      {aboutUs && aboutUs.length > 0 && (
        <section className="mrv-about-premium py-5">
          <div className="container py-lg-5">
            <div className="row align-items-center g-5">
              <div className="col-lg-6">
                <div className="about-image-wrapper">
                  <div className="image-accent" />
                  <img
                    src={aboutInfo?.image}
                    alt="MRV Campus"
                    className="img-fluid main-img"
                    loading="lazy"
                  />

                  <div className="floating-card about-logo-card">
                    <div className="about-logo-circle">
                      <img
                        src={aboutInfo?.logo}
                        alt="MRV Logo"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-content">
                  <span className="mrv-subtitle">{aboutInfo?.type}</span>
                  <h2 className="mrv-title mb-1">{aboutInfo?.name}</h2>
                  <p
                    className="mrv-text mb-3"
                    dangerouslySetInnerHTML={{
                      __html: aboutInfo?.description || "",
                    }}
                  />

                  <div className="d-flex align-items-center gap-4">
                    <Link to="/about-us" className="btn mrv-btn-outline">
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* counter section */}
      {featured && featured.length > 0 && (
        <section ref={sectionRef} className="mrv-stats-section py-3">
          <div className="stats-overlay" />

          <div className="container position-relative z-3">
            <div className="row g-4 text-center justify-content-center">
              {featured.map((item, index) => (
                <div key={index} className="col-6 col-md-3">
                  <div className="stat-card">
                    <div className="stat-icon">
                      <img
                        className="count-image"
                        src={item.image}
                        alt={item.label}
                        loading="lazy"
                      />
                    </div>

                    <div className="counter-wrapper">
                      <h2 className="counter">
                        {item.count}
                        {/* <Odometer
                          value={startCount ? parseInt(item.count, 10) : 0}
                          format="(,ddd)"
                          theme="default"
                        /> */}
                      </h2>

                      <span className="plus">+</span>
                    </div>

                    <p className="stat-label">{item.name}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* why choose mrv */}
      {chooseMrv && chooseMrv.length > 0 && (
        <section className="mrv-why-us pt-5 bg-light">
          <div className="container py-5">
            <div className="text-start mb-3">
              <h6 className="mrv-subtitle">Our Excellence</h6>
              <h2 className="mrv-title">Why Choose MRV School?</h2>
            </div>

            <div className="row g-4">
              {chooseMrv.map((item, index) => (
                <div key={index} className="col-lg-3 col-md-6">
                  <FeaturedCard
                    item={{
                      icon: item.logo,
                      title: item.title,
                      desc: item.description.replace(/<[^>]+>/g, ""),
                    }}
                    index={index}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* registration cta section */}

      {siteConfig?.erp_registration_link &&
        admissionCta &&
        admissionCta.length > 0 && (
          <section className="mrv-registration-cta-full">
            <div className="mrv-cta-overlay-pattern" />
            <div className="container">
              <div className="mrv-cta-full-inner">
                <span className="mrv-cta-badge">
                  Session {siteConfig.admission_batch}
                </span>
                <h2 className="mrv-cta-huge-text">{admissionCtaInfo.title}</h2>
                <h4 className="mrv-cta-huge-subtext">
                  {admissionCtaInfo.subtitle}
                </h4>
                <p className="mrv-cta-subtext">{admissionCtaInfo.name}</p>
                <a href={siteConfig.erp_registration_link} className="mrv-cta-full-btn" target="_blank">
                  <span>Register Now</span>
                  <i className="bi bi-arrow-right-circle-fill" />
                </a>
              </div>
            </div>
          </section>
        )}

      {/* facilities section */}
      {campus && campus.length > 0 && (
        <section className="mrv-facilities py-5">
          <div className="container">
            <div className="row align-items-end mb-3">
              <div className="col-12">
                <h2 className="mrv-title">Our Campus Facilities</h2>
              </div>
            </div>
            <div className="row g-3">
              {campus.map((item, index) => (
                <div key={index} className="col-lg-4 col-md-6">
                  <div className="facility-box shadow-sm">
                    <div className="facility-img">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="img-fluid"
                        loading="lazy"
                      />
                      <div className="facility-overlay">
                        <img
                          src={item.logo}
                          alt={item.title}
                          className="icon-facility"
                          loading="lazy"
                        />
                        <h4>{item.title}</h4>
                        <h6>({item.subtitle})</h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {alumni && alumni.length > 0 && <AlumniSection alumni={alumni} />}

      {/* news udpates */}
      <section className="news-updates-section py-5 bg-white">
        <div className="container">
          <div className="row g-4">
            {newsEvents && newsEvents.length > 0 && (
              <div className="col-lg-8">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h3 className="mrv-title">Latest Events & News</h3>
                  <Link
                    to="/news-and-events"
                    className="btn btn-sm btn-link text-maroon fw-bold text-decoration-none"
                  >
                    View All News →
                  </Link>
                </div>

                <div className="row g-4">
                  {newsEvents.slice(0, 2).map((news) => (
                    <NewsEventsCard
                      key={news.id}
                      news={news}
                      colClass="col-lg-6 col-md-6 col-filter"
                    />
                  ))}
                </div>
              </div>
            )}
            <div className="col-lg-4">
              <div className="notice-board-wrapper h-100 shadow-sm">
                <div className="notice-header p-3">
                  <h4 className="m-0 text-white">
                    <i className="bi bi-megaphone-fill me-2" /> Notice Board
                  </h4>
                </div>

                <div className="notice-container">
                  <div className="notice-scroll">
                    {noticeData.map((notice) => (
                      <NoticeInfo key={notice.id} notice={notice} />
                    ))}
                  </div>
                </div>

                {/* <div className="notice-footer p-3 text-center border-top">
                  <a
                    href="#"
                    className="fw-semibold text-white text-decoration-none"
                  >
                    See All Notifications
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* parents reviews */}
      {testimonial && testimonial.length > 0 && <Reviews data={testimonial} />}

      {/* teachers methodology */}
      {teachingMethodology && teachingMethodology.length > 0 && (
        <section className="mrv-methodology-video py-5">
          <div className="container">
            {/* heading */}
            <div className="text-left mb-3">
              <h2 className="mrv-title">Our Teaching Methodology</h2>
            </div>

            <div className="row align-items-center g-4">
              {/* VIDEO SIDE */}
              <div className="col-lg-6">
                <div className="teaching-image">
                  <img
                    src={teachingInfo?.image}
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
              </div>

              {/* CONTENT SIDE */}
              <div className="col-lg-6">
                <div className="method-video-content">
                  <h4 className="fw-bold mb-3">{teachingInfo?.title}</h4>
                  <p
                    className="mrv-text mb-3"
                    dangerouslySetInnerHTML={{
                      __html: teachingInfo?.description || "",
                    }}
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* gallery section */}
      {gallery && gallery.length > 0 && (
        <section className="mrv-gallery-section py-5">
          <div className="container">
            <div className="row align-items-end mb-3">
              <div className="col-md-8">
                <h2 className="mrv-title">Gallery Events</h2>
              </div>
              <div className="col-md-4 text-md-end">
                <Link
                  to="/gallery"
                  className="btn explore-btn rounded-0 text-decoration-none"
                >
                  Explore More
                </Link>
              </div>
            </div>

            <div className="row g-3">
              {gallery.map((item, index) => (
                <div key={index} className="col-lg-4 col-md-6">
                  <div className="gallery-item shadow-sm">
                    <img
                      src={item.gallery_images}
                      alt="Gallery"
                      className="img-fluid"
                      loading="lazy"
                    />
                    <div className="gallery-overlay"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* admission section */}
      {admission && admission.length > 0 && (
        <section className="admission-section py-5 bg-light">
          <div className="container">
            <div className="row g-0">
              <div
                className="col-lg-7 p-4 text-white"
                style={{ backgroundColor: "var(--secondary-color)" }}
              >
                <h2 className="fw-bold mb-4">Admission Guidelines 2026-27</h2>
                <ul className="list-unstyled">
                  {admission.map((item, index) => (
                    <li key={item.id} className="mb-2 d-flex">
                      <i className="bi bi-check-circle-fill me-3 text-white" />
                      <div>
                        <h5>{item.name}</h5>
                        <p
                          className="small text-white opacity-55"
                          dangerouslySetInnerHTML={{
                            __html: item.description || "",
                          }}
                        ></p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="col-lg-5 p-md-5 p-2">
                <h3 className="fw-bold text-primary-mrv mb-4">Enquire Now</h3>
                <EnquiryForm />
              </div>
            </div>
          </div>
        </section>
      )}

      {/* location section */}
      <section className="mrv-location-section py-5">
        <div className="container">
          <div className="location-wrapper d-flex flex-column flex-md-row">
            {/* LEFT INFO */}
            <div className="location-info p-4">
              {/* image */}
              <div className="location-img-container mb-3">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/img/school_gate.webp`}
                  alt="MRV School"
                  className="img-fluid shadow-sm"
                  loading="lazy"
                />
              </div>

              {/* details */}
              <div className="location-details">
                <h6
                  className="fw-bold mb-1"
                  style={{ fontSize: "15px", color: "#000" }}
                >
                  {siteConfig.siteName}
                </h6>

                <p
                  className="mb-4"
                  style={{
                    color: "var(--text-grey-color)",
                    fontSize: "14px",
                    lineHeight: "22px",
                  }}
                >
                  {siteConfig.address}
                </p>

                <a
                  href="https://maps.app.goo.gl/E2YDnZQmiukq2qrt8"
                  className="mrv-btn-outline text-decoration-none"
                  target="_blank"
                  rel="noreferrer"
                >
                  Get Directions
                </a>
              </div>
            </div>

            {/* RIGHT MAP */}
            <div className="location-map flex-grow-1">
              <MapSection height="100%" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
